.selectionListItemContent {
  gap: var(--dixa-size-spacer-200);
}
